/* eslint-disable security/detect-object-injection */
import { boostBuildPreferences } from './boostBuildPreferences';
import { boostBodyType } from './boostBodyType';
import { getPriceBodyMatch } from './getPriceBodyMatch';
import { moveBackTwoIndices } from './moveBackTwoIndices';

export function getReccomendationsForMLPBuildMix(
  lastBuildModelName,
  savedBuildBodyTypes,
  buildPriceCategory,
  rankedBodyTypes,
  rankedPriceRanges,
  numberOfReccomendationsNeeded,
) {
  const finalReccomendations = [];
  const alreadySelectedModels = [];

  alreadySelectedModels.push(lastBuildModelName);
  finalReccomendations.push(lastBuildModelName);

  boostBuildPreferences(rankedPriceRanges, buildPriceCategory);
  boostBodyType(savedBuildBodyTypes, rankedBodyTypes);

  const configuratorModelWithBoostSuggestion = getPriceBodyMatch(
    numberOfReccomendationsNeeded - 1,
    rankedPriceRanges,
    rankedBodyTypes,
    alreadySelectedModels,
  );

  alreadySelectedModels.push(configuratorModelWithBoostSuggestion[0]);
  finalReccomendations.push(configuratorModelWithBoostSuggestion[0]);

  const reRankedPriceRanges = moveBackTwoIndices(rankedPriceRanges, buildPriceCategory);

  let reRankedBodyTypes;

  for (let i = 0; i < savedBuildBodyTypes?.length; i += 1) {
    reRankedBodyTypes = moveBackTwoIndices(rankedBodyTypes, savedBuildBodyTypes[i]);
  }

  const baselineSuggestion = getPriceBodyMatch(
    numberOfReccomendationsNeeded - 1,
    reRankedPriceRanges,
    reRankedBodyTypes,
    alreadySelectedModels,
  );

  finalReccomendations.push(baselineSuggestion[0]);
  return finalReccomendations;
}
